/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Col_ItemsInputs */

const en_pwf_col_items = /** @type {(inputs: Pwf_Col_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_pwf_col_items = /** @type {(inputs: Pwf_Col_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgänge`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Pwf_Col_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_col_items = /** @type {((inputs?: Pwf_Col_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Col_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_col_items(inputs)
	return en_pwf_col_items(inputs)
});